import { render } from "./Organizational-services-en.vue?vue&type=template&id=08e9938b&scoped=true"
import script from "./Organizational-services-en.vue?vue&type=script&lang=js"
export * from "./Organizational-services-en.vue?vue&type=script&lang=js"

import "./Organizational-services-en.vue?vue&type=style&index=0&id=08e9938b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e9938b"]])

export default __exports__